<kui-modal class="comment-modal" [title]="title" size="lg" (onClose)="cancel()" [actions]="actions" (onOpen)="opened()">
    <div class="p-3">
        <textarea [placeholder]="'SHARED.FEED.TYPE_COMMENT' | translate" #commentTextArea [(ngModel)]="comment" class="form-control" id="exampleTextarea" rows="5"></textarea>
    </div>
</kui-modal>
